import { render, staticRenderFns } from "./SchedulingCard.vue?vue&type=template&id=53146538&scoped=true"
import script from "./SchedulingCard.vue?vue&type=script&lang=js"
export * from "./SchedulingCard.vue?vue&type=script&lang=js"
import style0 from "./SchedulingCard.vue?vue&type=style&index=0&id=53146538&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53146538",
  null
  
)

export default component.exports